$(function () {
	const $module = $('.module-accesrapide');
	if (!$module.length) return;

	const $wrap = $module.find('.mar-wrap');

	const $ph = $('<div class="mar-wrap-ph" aria-hidden="true"></div>').hide();
	$ph.insertAfter($wrap);

	let lastY = window.pageYOffset || 0;
	let anchorTop = 0;
	let ticking = false;

	function syncPlaceholder() {
		$ph.height($wrap.outerHeight(true));
	}

	function computeAnchor() {
		anchorTop = $module.offset().top;
		syncPlaceholder();
	}

	function setFixed(on) {
		if (on) {
			if (!$module.hasClass('fixed')) {
				$module.addClass('fixed');
				syncPlaceholder();
				$ph.show();
			}
		}
		else {
			if ($module.hasClass('fixed')) {
				$module.removeClass('fixed');
				$ph.hide().height(0);
			}
		}
	}

	function onScroll() {
		if (ticking) return;
		ticking = true;

		requestAnimationFrame(() => {
			const y = window.pageYOffset || document.documentElement.scrollTop;
			const goingDown = y > lastY;

			if (goingDown && y >= anchorTop) {
				setFixed(true);
			}
			else if (!goingDown && y < anchorTop) {
				setFixed(false);
			}

			lastY = y;
			ticking = false;
		});
	}

	computeAnchor();
	if ((window.pageYOffset || document.documentElement.scrollTop) >= anchorTop) {
		setFixed(true);
	}

	$(window).on('scroll', onScroll);

	$(window).on('resize', () => {
		requestAnimationFrame(() => {
			const wasFixed = $module.hasClass('fixed');
			setFixed(false);
			computeAnchor();
			if (wasFixed && window.pageYOffset >= anchorTop) setFixed(true);
		});
	});

	$(window).on('load', () => {
		computeAnchor();
		if (window.pageYOffset >= anchorTop) setFixed(true);
	});
});


$(function () {
	const $carousel = $('.mar-carousel');
	let slick_reset = true;
	$carousel.slick({
		dots: false,
		arrows: false,
		infinite: false,
		autoplay: false,
		autoplaySpeed: 3000,
		mobileFirst: false,
		adaptiveHeight: true,
		centerMode: false,
		variableWidth: true,
		touchThreshold: 30
	});

	function moveToActiveLink(link) {
		let slide_w = 0;
		const carou = $(link).closest(".mar-carousel");
		carou.find('.slick-slide').each(function(){
			
			slide_w = slide_w + $(this).width();
		});
		
		if (slide_w > carou.width()){
		
			const $li = $(link).closest('.slick-slide');
			const index = $li.attr("data-slick-index");

			if (index >= 0 && $carousel.hasClass('slick-initialized')) {
				$carousel.slick('slickSetOption', 'centerMode', true, true);
				$carousel.slick('slickGoTo', index);
				slick_reset = false;
			}
		}else{
			if(!slick_reset){
				$carousel.slick('unslick');
				$carousel.slick({
					dots: false,
					arrows: false,
					infinite: false,
					autoplay: false,
					autoplaySpeed: 3000,
					mobileFirst: false,
					adaptiveHeight: true,
					centerMode: false,
					variableWidth: true,
					touchThreshold: 30
				});
				slick_reset = true;
			}
			
		}
		
	}

	if ($('.jssticky').length) {
		const links = document.querySelectorAll('.mar-link');
		const sections = [];

		links.forEach(link => {
			const id = link.getAttribute('href').replace('#', '');
			const section = document.getElementById(id);

			if (section) {
				sections.push({ id, section, link });
			}
		});

		const spyObserver = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				const found = sections.find(s => s.section === entry.target);

				if (entry.isIntersecting && found) {
					$('.mar-link').removeClass('active');
					found.link.classList.add('active');
					moveToActiveLink(found.link);
				}
			});
		}, {
			rootMargin: '-50% 0px -50% 0px',
			threshold: 0
		});

		sections.forEach(s => spyObserver.observe(s.section));

		const $initialActive = $('.mar-link.active').first();
		if ($initialActive.length) {
			moveToActiveLink($initialActive[0]);
		}
	}
});
